





import { Component, Prop, Vue, Watch, CurrentUserState } from "division-marker";

@Component({ components: {}, mixins: [] })
export default class Top extends Vue {
  @Prop() private msg!: string;
  get state(): CurrentUserState {
    return this.$store.state.current_user;
  }
  mounted() {
    if (this.state.user == null) {
      window.location.href = "#/sign_in";
    } else {
      window.location.href = "#/dm/question_answers";
    }
  }

  @Watch("state.user")
  msg_changed(to: any) {
    if (to != null) {
      const top_url = this.$store.getters["current_user/top_url"];
      window.location.href = top_url;
    }
  }
}
